/** Ordine commerciale piani SaaS palestra (per badge upgrade). */
export const GYM_SAAS_PLAN_ORDER = ['start', 'premium', 'elite'];

export function gymSaasPlanRank(planId) {
    const idx = GYM_SAAS_PLAN_ORDER.indexOf(planId);
    return idx >= 0 ? idx : GYM_SAAS_PLAN_ORDER.length;
}

export function resolveCurrentSaasPlanId(billing) {
    if (!billing) {
        return null;
    }
    if (billing.commercial_plan) {
        return billing.commercial_plan;
    }
    if (billing.billing_status === 'trialing' && billing.trial_feature_level) {
        return billing.trial_feature_level;
    }
    return billing.plan || null;
}

export function currentPlanFeatureKeySet(plans, currentPlanId) {
    if (!currentPlanId || !Array.isArray(plans)) {
        return new Set();
    }
    const plan = plans.find((p) => p.id === currentPlanId);
    if (!plan) {
        return new Set();
    }
    const keys = (plan.display_features || []).map((f) => f.key);
    if (keys.length) {
        return new Set(keys);
    }
    if (plan.feature_keys && typeof plan.feature_keys === 'object') {
        return new Set(
            Object.entries(plan.feature_keys)
                .filter(([, allowed]) => allowed)
                .map(([key]) => key),
        );
    }
    return new Set();
}

/** Badge «in più» rispetto al piano attuale, solo su piani superiori. */
export function isFeatureNewInPlan(planId, featureKey, currentPlanId, currentFeatureKeys) {
    if (!currentPlanId || planId === currentPlanId) {
        return false;
    }
    if (gymSaasPlanRank(planId) <= gymSaasPlanRank(currentPlanId)) {
        return false;
    }
    if (featureKey.startsWith('_core_')) {
        return false;
    }
    return !currentFeatureKeys.has(featureKey);
}
